import styled from 'styled-components'

export const Licensed = styled.div`
  display: flex;
  justify-content: center;
  margin-left: 30px;
`
